/* eslint-disable */
const wxShare = options => {
    // 微信的分享
    // 依赖http://res.wx.qq.com/open/js/jweixin-1.0.0.js
    var jsApiListOpt = [
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'onMenuShareQZone'
    ];
    wx.ready(function () {
        /* config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，
            config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。
            对于用户触发时才调用的接口，
            则可以直接调用，不需要放在ready函数中
        */
        // 检查微信是否支持
        wx.checkJsApi({
            jsApiList: jsApiListOpt, // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function (res) {
                // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
                var title = options.titleName;
                var link = options.link;
                var imgUrl = options.image;
                var desc = options.content;
                if (res.checkResult.onMenuShareTimeline) {
                    // alert(6666);
                    wx.onMenuShareTimeline({
                        title: title, // 分享标题
                        link: link, // 分享链接
                        imgUrl: imgUrl, // 分享图标
                        success: function () {
                            // 用户确认分享后执行的回调函数
                            // alert(1111);
                        },
                        cancel: function () {
                            // 用户取消分享后执行的回调函数
                        }
                    });
                }
                // 获取“分享给朋友”按钮点击状态及自定义分享内容接口
                if (res.checkResult.onMenuShareAppMessage) {
                    wx.onMenuShareAppMessage({
                        title: title, // 分享标题
                        desc: desc, // 分享描述
                        link: link, // 分享链接
                        imgUrl: imgUrl, // 分享图标
                        type: '', // 分享类型,music、video或link，不填默认为link
                        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                        success: function () {
                            // 用户确认分享后执行的回调函数
                            // alert(7771);
                        },
                        cancel: function () {
                            // 用户取消分享后执行的回调函数
                            // alert(7772);
                        }
                    });
                }
                // 获取“分享到QQ”按钮点击状态及自定义分享内容接口
                if (res.checkResult.onMenuShareQQ) {
                    wx.onMenuShareQQ({
                        title: title, // 分享标题
                        desc: desc, // 分享描述
                        link: link, // 分享链接
                        imgUrl: imgUrl, // 分享图标
                        success: function () {
                            // 用户确认分享后执行的回调函数
                        },
                        cancel: function () {
                            // 用户取消分享后执行的回调函数
                        }
                    });
                }
                // 获取“分享到腾讯微博”按钮点击状态及自定义分享内容接口
                if (res.checkResult.onMenuShareWeibo) {
                    wx.onMenuShareWeibo({
                        title: title, // 分享标题
                        desc: desc, // 分享描述
                        link: link, // 分享链接
                        imgUrl: imgUrl, // 分享图标
                        success: function () {
                            // 用户确认分享后执行的回调函数
                        },
                        cancel: function () {
                            // 用户取消分享后执行的回调函数
                        }
                    });
                }
                // 获取“分享到QQ空间”按钮点击状态及自定义分享内容接口
                if (res.checkResult.onMenuShareQZone) {
                    wx.onMenuShareQZone({
                        title: title, // 分享标题
                        desc: desc, // 分享描述
                        link: link, // 分享链接
                        imgUrl: imgUrl, // 分享图标
                        success: function () {
                            // 用户确认分享后执行的回调函数
                        },
                        cancel: function () {
                            // 用户取消分享后执行的回调函数
                        }
                    });
                }

            }
        });
        // 在config中debug: true就好了
        // wx.error(function (res) {
        //     alert(res.errMsg);
        // });
        // wx.hideOptionMenu();
    });
}

const initWeixin = (data, shareOpt) => {
    const jsApiListOpt = ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'];
    try {
        window.wx.config({
            // debug: true,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: jsApiListOpt
        });
        wxShare(shareOpt);
    } catch (e) {
        console.log(e);
    }
};

export default (shareInfo = {}) => {
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//y.gtimg.cn/music/js/lib/jquery-min.js';
    console.log(window.$)
    head.appendChild(script);
    script.onload = () => {
      $.ajax({
        // url: 'http://10.31.16.72:8080/v2/wx/shareConfig',
        url: 'https://y.tencentmusic.com/v2/wx/shareConfig',
        type: 'POST',
        contentType: "application/json",
        dataType: 'json',
        data: JSON.stringify({
          shareUrl: window.location.href.split("#")[0]
        }),
        success: function (res) {
          if (+res.code === 0 && res.data) {
            initWeixin(res.data, {
              image: shareInfo.imgUrl || 'https://yobang.tencentmusic.com/share.png',
              titleName: shareInfo.title || '你的小伙伴请你定义流行',
              content: shareInfo.desc || '糟糕，是心动的感觉！这首歌太好听了，忍不住分享给你，喜欢的话就点个赞吧^_^',
              link: shareInfo.link || 'https://yobang.tencentmusic.com/index.html#/'
            })
          }
        }
      });
    }
}